import T from 'core/i18n/t'
import { Component, Fragment } from 'react'
import useFrequenciesFilter from '../context/hook'
import filterFrequency from '../lib/filterFrequency'
import { frequencyScanMapping, getModule } from '../lib/rfMapping'
import { getCellStatusColor, getRowStatusColor } from '../lib/thresholds'
import { FrequenciesFilterState } from '../lib/types'
import { RfTuningLimitValues, RfTuningStatusResult } from './redux/types'

type HoCRfTuningTableComponentProps = {
  frequencyHistories?: Array<RfTuningStatusResult>
  frequencyLimits?: Array<RfTuningLimitValues>
}

type RfTuningTableComponentProps = HoCRfTuningTableComponentProps & {
  filter: FrequenciesFilterState
}

export default function HoCRfTuningTableComponent(props: HoCRfTuningTableComponentProps) {
  const { filter } = useFrequenciesFilter()
  return <RfTuningTableComponent filter={filter} {...props}/>
} 
class RfTuningTableComponent extends Component<RfTuningTableComponentProps> {
  public render() {
    const { frequencyHistories = [], frequencyLimits, filter } = this.props

    const mappedFrequencies = frequencyScanMapping(frequencyHistories, frequencyLimits)
    const filteredFrequencies = filterFrequency(mappedFrequencies, filter)
    
    return (
      <Fragment>
        <div className="table-optimized" role="table">
          <div className="flex-table header has-status" role="rowgroup">
            <div className="flex-cell" role="columnheader">
              <T>rf_tuning.full_frequency_lf</T>
            </div>
            <div className="flex-cell" role="columnheader">
              <T>rf_tuning.full_frequency_pwr</T>
            </div>
            <div className="flex-cell" role="columnheader">
              <T>rf_tuning.full_frequency_berpo</T>
            </div>
            <div className="flex-cell" role="columnheader">
              <T>rf_tuning.full_frequency_ls</T>
            </div>
            <div className="flex-cell" role="columnheader">
              <T>rf_tuning.full_frequency_tsid</T>
            </div>
            <div className="flex-cell" role="columnheader">
              <T>rf_tuning.full_frequency_modulation</T>
            </div>
          </div>

          {filteredFrequencies.map((row, index: number) => (
              <div className="flex-table row" role="rowgroup" key={index}>
                <div className="has-status" role="cell">
                  <span className={`is-status ${getRowStatusColor(row.PWR.isHealthy, row.BERPO.isHealthy)}`}></span>
                </div>

                <div className="flex-cell" role="cell">
                  {row.LF}
                </div>

                <div className={`flex-cell ${getCellStatusColor(row.PWR.isHealthy)}`} role="cell">
                  {row.PWR.value}
                </div>

                <div className={`flex-cell ${getCellStatusColor(row.BERPO.isHealthy)}`} role="cell">
                  {row.BERPO.value}
                </div>

                <div className="flex-cell" role="cell">
                  {row.LS}
                </div>

                <div className="flex-cell" role="cell">
                  {row.TSID}
                </div>

                <div className="flex-cell" role="cell">
                  {getModule(row.LF, this.props.frequencyLimits)}
                </div>
              </div>
            ))}
        </div>
      </Fragment>
    )
  }
}
